<div class="modal-header">
  <h4 class="modal-title pull-left">
    <app-icon icon="map-pin" iconClass="button-icon"></app-icon> {{modalTitle}}
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

<div class="modal-body">
  <form class="form-horizontal" action="" #addHospitaLocationForm="ngForm" [hidden]="showConfirmDeleteMessage">
    <div class="form-group">
      <label class="col-sm-3 control-label">Current Address</label>
      <div class="input-group mb-3">
        <input id="address-input" type="text" name ="location-address" class="form-control" autocomplete="on" [placeholder]="location.current_address ? location.current_address : 'Enter Address'" [(ngModel)]="location.current_address"/>
        @if (errorInSelectedAddress) {
          <div class="form-error">
            <p>Please select a specific address</p>
          </div>
        }
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-3 control-label">Location Name</label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" name="location-name" required [readonly]="!isEditing"
          placeholder="Location Name" [(ngModel)]="location.name">
      </div>
    </div>
    @if (venuesList && venuesList.length) {
      <div class="form-group">
        <label class="col-sm-3 control-label">Venue</label>
        <div class="col-sm-9">
          <select class="form-control" name="zone" [(ngModel)]="location.venue_mapping['id']" #venue_mapping="ngModel" [disabled]="!isEditing">
            <option value=null selected="selected" disabled>--Select--</option>
            @for (venue_mapping of venuesList; track venue_mapping) {
              <option value="{{venue_mapping.id}}" [selected]="location.venue_mapping['id'] === venue_mapping.id">
                {{venue_mapping.zone_name}}
              </option>
            }
          </select>
        </div>
      </div>
    }
  </form>
  @if (showConfirmDeleteMessage) {
    <p>Are you sure, you want to delete this location?</p>
  }
</div>

@if (isEditing && !showConfirmDeleteMessage) {
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary" (click)="addUpdateLocation()" [disabled]="addHospitaLocationForm.form.invalid || errorInSelectedAddress">
      Save Changes
    </button>
  </div>
}

@if (showConfirmDeleteMessage) {
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="closeDelete()">Close</button>
    <button type="button" class="btn btn-danger" (click)="deleteLocation()">
      Delete
    </button>
  </div>
}

@if (!isEditing) {
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="confirmLocationDeleteModal()">Delete</button>
    <button type="button" class="btn btn-primary" (click)="editLocation()">Edit</button>
  </div>
}
